import * as types from '../actions/types'
import Immutable from 'immutable'

import { tableCols, findvalues } from '../containers/Grupos'
import { isPrimitive, grupo } from '../utils/helpers'

const columnas = Immutable.fromJS(tableCols)

const INITIAL_STATE = Immutable.fromJS({
    grupos: [],
    permisos: [],
    permisosGrupo: [],
    page: 1,
    selected: null,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: null,
		asc: false
	},
	modalCreate: {
		title: '',
		mode: '',
		show: false,
		data: null,
		unchanged: null,
		btnDisabled: false,
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
	modalFilter: {
		show: false,
		filters: []
	},
})

export default function (state = INITIAL_STATE, action) {
	let id
	let data
	let index
	switch (action.type) {
		case types.OBTENER_GRUPOS:
			state = state.set('grupos', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords)
			state = state.set('permisos', Immutable.fromJS(action.payload.permisos))
			return state
		case types.ORDENAR_GRUPOS:
			state = state.set('orderBy', action.payload.orderBy)
			return state
		case types.MOSTRAR_MODAL_CREAR_GRUPO:
			state = state.setIn(['modalCreate', 'show'], action.payload.show)
			state = state.setIn(['modalCreate', 'title'], action.payload.title)
			state = state.setIn(['modalCreate', 'mode'], action.payload.mode)
			if (action.payload.mode === 'create') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(grupo()))
				state = state.setIn(['modalCreate', 'unchanged'], state.setIn(['modalCreate', 'data']))
			} else if (action.payload.mode === 'edit') {
                data = state.getIn(['grupos',String(action.payload.index)])
				state = state.setIn(['modalCreate', 'data'], data)
				state = state.setIn(['modalCreate', 'unchanged'], data)
			}
			return state
		case types.MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS:
			state = state.setIn(['modalCreate', 'data', action.payload.attr], action.payload.value)
			return state
		case types.CREAR_ACTUALIZAR_GRUPO:
			id = action.payload.id
			index = state.get('grupos').findIndex(x => x.get('id') === id)
			if (index !== -1) {
				state = state.setIn(['grupos', index], Immutable.fromJS(action.payload))
			} else {
				state = state.set('grupos', state.get('grupos').push(Immutable.fromJS(action.payload)))
			}
			state = state.setIn(['modalCreate', 'show'], false)
			state = state.setIn(['modalCreate', 'title'], '')
			state = state.setIn(['modalCreate', 'mode'], '')
			state = state.setIn(['modalCreate', 'data'], null)
			return state
		case types.DESHABILITAR_BOTON_MODAL_GRUPOS:
			state = state.setIn(['modalCreate', 'btnDisabled'], action.payload)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_GRUPO:
			index = state.get('grupos').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['grupos', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS:
            state = state.setIn(['modalFilter', 'show'], action.payload)
            return state
        case types.ADICIONAR_CRITERIO_FILTRADO_GRUPOS:
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_GRUPOS:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_GRUPOS:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('value') === action.payload.value).get('type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_GRUPOS:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state
		case types.MODIFICAR_INPUTS_GRUPOS:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
        case types.SELECCIONAR_ITEM_GRUPOS:
            state = state.set('selected', action.payload)
            let permisos = state.get('permisos')
            let permisosGrupo = state.getIn(['grupos',String(action.payload),'permisos'])
            permisos = permisos.map(x => {
                if (permisosGrupo.filter(k => k.get('id') === x.get('id')).count() !== 0) {
                    x = x.set('selected', true)
                }
                return x
            })
            state = state.set('permisosGrupo', permisos)
            return state
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/grupos.js